import { encrypt } from '../helpers/Helpers';

export default async function Login({username, password, IP, Session}) {
    // Encriptar credenciales antes de enviar
    const encryptedUsername = encrypt(username, process.env.REACT_APP_KEY);
    const encryptedPassword = encrypt(password, process.env.REACT_APP_KEY);

    const url = "https://labs.azulhandling.org/Login/procesos_seguros/login.php";
    const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            username: encryptedUsername,
            password: encryptedPassword,
            IP,
            Session
        }),
    })
    
    if(res.status == 200){
        return await res.json()
    }else{
        return "Error obteniendo los datos"
    }
}